import Blue from "~/core";

new Blue({
	name: 'Cookie Consent',
	selector: ".js-cookie-consent",
	setup(cookies) {
		const closeBtn = cookies.querySelector(".js-cookie-revoke");
		const accept = cookies.querySelector(".js-cookie-accept");
		const ctaLink = cookies.querySelector(".cookie-consent__policy");

		function getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i <ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return false;
		}

		function setCookie(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires="+ d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}

		if (!getCookie("acceptedCookies")) {
			setTimeout(() => {
				cookies.classList.add("is-visible");
				closeBtn.setAttribute("tabindex", 1);
				ctaLink.setAttribute("tabindex", 1);
				accept.setAttribute("tabindex", 1);
			}, 100);
		}

		const acceptCookies = () => {
			cookies.classList.remove("is-visible");
			setCookie("acceptedCookies", true, 365);
			if(typeof onTrackJSUserConsent === "function"){
				onTrackJSUserConsent();
			}			
		}
		const rejectCookies = () => {
			cookies.classList.remove("is-visible");
			setCookie("acceptedCookies", false, 365);
		}

		this.$addEvents(closeBtn, "click enter", rejectCookies);
		this.$addEvents(accept, "click enter", acceptCookies);

				// PREVIOUS STRATEGY BASED ON LOCAL STORAGE
				// SWITCHED TO COOKIE JS STRATEGY ON 5/19/22
        // const cookieAccept = localStorage.getItem('fgCookieNoticeSeen')
        // let prevFocus
        // if(!cookieAccept) {
        //     const acceptBtn = cookieConsent.querySelector('.js-cookie-accept'),
        //         revokeBtn = cookieConsent.querySelector('.js-cookie-revoke'),
        //         firstFocusEl = cookieConsent.querySelector('.cookie-consent__heading')
        //     cookieConsent.classList.add('is-visible')
        //     // setting prev focus only if user was focused somewhere
        //     if(document.hasFocus()) {
        //         prevFocus = document.activeElement
        //     }
        //     cookieConsent.focus({preventScroll:true})
        //     cookieConsent.addEventListener('focusout', () => {
        //         if (!cookieConsent.matches(':focus-within')) {
        //             firstFocusEl.focus()
        //         }
        //     })
        //     this.$addEvents(acceptBtn, 'click.prevent enter.prevent', function() { 
        //         localStorage.setItem('fgCookieNoticeClick', 'accept')
        //         setCookieNoticeSeen()
        //     })
        //     this.$addEvents(revokeBtn, 'click.prevent enter.prevent', function() {
        //         localStorage.setItem('fgCookieNoticeClick', 'revoke')
        //         setCookieNoticeSeen()
        //     })
        // }   
        // function setCookieNoticeSeen() {
        //     // this should be a transitionend listener but that function fires often on the components page
        //     cookieConsent.remove()
        //     if(prevFocus) {
        //         // restoring previous focus
        //         prevFocus.focus({preventScroll:true})
        //     }
        //     return localStorage.setItem('fgCookieNoticeSeen', true)
        // }

    }
})